import { useEffect } from "react";
import { checkOnReturn, markBusy } from "./staleBuild";

/**
 * A screen that can send (Book's flow, account creation): check for a newer
 * release when the person returns to the tab, and tell the check while a send
 * is in flight or its outcome uncertain (`busy`), so nothing interrupts it.
 */
export function useStaleBuildGuard(busy: boolean): void {
  useEffect(() => {
    if (!busy) return;
    markBusy(true);
    return () => markBusy(false);
  }, [busy]);

  useEffect(() => {
    const onReturn = () => {
      if (document.visibilityState === "visible") checkOnReturn();
    };
    window.addEventListener("focus", onReturn);
    document.addEventListener("visibilitychange", onReturn);
    return () => {
      window.removeEventListener("focus", onReturn);
      document.removeEventListener("visibilitychange", onReturn);
    };
  }, []);
}
